export const postApiUrl = (path: string): URL => {
	const searchApiUrl = process.env.NEXT_PUBLIC_SEARCH_API_URL;
	return new URL('/api/v1/' + trimSlashes(path), searchApiUrl);
};

const trimSlashes = (str: string): string => {
	return str.replace(/^\/+/, '').replace(/\/+$/, '');
};
